var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jobs"},[_c('h1',[_vm._v("Pending/Active Jobs")]),_c('div',{staticClass:"table-wrapper loader-container"},[(_vm.jobs)?_c('vue-good-table',{attrs:{"columns":[
        {
          label: 'Customer',
          field: 'customerComponent.customer.customerName'
        },
        {
          label: 'Component',
          field: 'customerComponent.component.componentName'
        },
        {
          label: 'Action',
          field: 'action'
        },
        {
          label: 'Date Created',
          field: 'dateCreated',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Created By',
          field: 'createdBy'
        },
        {
          label: 'Date Run',
          field: 'dateRun',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Run By',
          field: 'runBy'
        },
        {
          label: 'Date Completed',
          field: 'dateCompleted',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Date Failed',
          field: 'dateFailed ',
          formatFn: _vm.formatDateTime
        },
        {
          label: 'Error',
          field: 'error'
        }
      ],"rows":_vm.jobs}}):_vm._e(),_c('Loader',{attrs:{"loading":_vm.loadingJobs}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }